import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import './NotFound.css'

const NotFound = (props) => {
	
  const [ t, i18n ] = useTranslation("global");
  
  useEffect(() => {
	  const userBrowserLang = getUserBrowserLanguage();

	  i18n.changeLanguage(userBrowserLang);
  }, [i18n]);
  
  const getUserBrowserLanguage = () => {
        const lang = window.navigator.language;

        if (lang.includes("es")) return "es";
        if (lang.includes("ca")) return "ca";
        if (lang.includes("en")) return "en";

        return "en";
  };
	
  return (
	  <div className={'mainNotFoundContainer'}>
		  <div className="login-form">
			  <div className="login-logo">
				  <a href={t("app.baseURL")}><img src={require("../../assets/img/logo.png")} alt="Login Logo" /></a>
			  </div>
			  <h1>{t('app.error.pageNotFoundTitle')}</h1>
		  	  <p>{t('app.error.pageNotFoundBody')}</p>
		  	  <a href={t('app.baseURL')}>{t('app.error.pageNotFoundLinkText')}</a>
		  </div>
		  
	  </div>
  )
}

export default NotFound